import { CellContent } from '../ToDoTableContent';

export function KonfliktWrapper({
  root,
  cause,
  borderRoot = true,
  borderCause = true,
}: {
  root: React.ReactNode;
  cause: React.ReactNode | null;
  borderRoot?: boolean;
  borderCause?: boolean;
}) {
  return (
    <div className="flex flex-col">
      <CellContent
        border={borderRoot}
        className={` ${cause === null ? '' : ' border-b-2 border-neutrals-300'}`}>
        {root}
      </CellContent>
      {cause !== null && <CellContent border={borderCause}>{cause}</CellContent>}
    </div>
  );
}
